import React from 'react';
import classNames from 'classnames';

import { Button } from '../../../../components';
import { FleetRuleFooterTranslations } from '../fleet-rule-utils';
import { FleetRuleFooterHandlers, FleetRuleFooterOptions } from '../fleet-rule-utils';

import styles from '../fleet-rule.module.scss';

interface RuleFooterProps {
	disabled?: boolean;
	fleetRuleFooterOptions: FleetRuleFooterOptions;
	fleetRuleFooterHandlers: FleetRuleFooterHandlers;
	translations?: FleetRuleFooterTranslations;
}

export const FleetRuleFooter = ({
	disabled = false,
	fleetRuleFooterOptions,
	fleetRuleFooterHandlers,
	translations
}: RuleFooterProps) => {
	const { discardButtonDisabled, saveButtonDisabled } = fleetRuleFooterOptions;
	const { onDiscard, onSave } = fleetRuleFooterHandlers;

	return (
		<div data-test-id="fleet-router-rule-footer " className={styles['rule-footer']}>
			<Button
				data-test-id="fleet-router-rule-footer-discard-button"
				className={classNames(styles['discard-button'], {
					[styles['disabled-button']]: disabled
				})}
				onClick={onDiscard}
				disabled={disabled || discardButtonDisabled}
			>
				{translations.discard}
			</Button>
			<Button
				data-test-id="fleet-router-rule-footer-save-button"
				type="primary"
				className={styles['save-button']}
				onClick={onSave}
				disabled={disabled || saveButtonDisabled}
			>
				{translations.save}
			</Button>
		</div>
	);
};
